<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius">
            <gofix-card title=" " class="mb-0" classContent="mb-0">
                <b-row>
                    <b-col md="3">
                        <gofix-form-dropdown
                            label="Property Type"
                            vLabel="reference_value_text"
                            :reduce="option => option.reference_value_text"
                            v-model="header.data.property_type"
                            :options="header.options.property_types">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="3">
                        <gofix-form-dropdown
                            label="Supplier Contract"
                            vLabel="contract_title"
                            @search="searchSupplierContract"
                            :filterable="false"
                            v-model="header.data.supplier_contract"
                            :options="header.options.supplier_contracts">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
            </gofix-card>
        </div>
        <gofix-card title=" " class="mb-0" classHeader="p-0 m-0" classContent="mb-0" fullContent>
            <gofix-tab
                class="mt-3 mb-0 contractPropertyChildTab"
                classTabContent="min-height-auto"
                :data="tabs"
                :variableWidth="true"
                activeKey="contract_sum">
                <template slot="gofixTab:contract_sum">
                    <ContractSum :propertyType="header.data.property_type" :contract="header.data.supplier_contract"/>
                </template>
                <template slot="gofixTab:maintenance_type_weightage">
                    <MaintenanceRegimeWeightage :propertyType="header.data.property_type" :contract="header.data.supplier_contract"/>
                </template>
                <template slot="gofixTab:other_sources_weightage">
                    <OtherSourcesWeightage :propertyType="header.data.property_type" :contract="header.data.supplier_contract"/>
                </template>
                <template slot="gofixTab:performance_computation">
                    <PerformanceComputation :propertyType="header.data.property_type" :contract="header.data.supplier_contract"/>
                </template>
                <template slot="gofixTab:rates_of_deduction">
                    <RatesOfDeduction :propertyType="header.data.property_type" :contract="header.data.supplier_contract"/>
                </template>
                <template slot="gofixTab:lump_sum_payment">
                    <LumpSumPayment :propertyType="header.data.property_type" :contract="header.data.supplier_contract"/>
                </template>
            </gofix-tab>  
        </gofix-card>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import tabData from '@/data/_tabs';
const ContractSum = () => import ('./contract-sum.vue');
const PerformanceComputation = () => import ('./performance-computation.vue');
const MaintenanceRegimeWeightage = () => import ('./maintenance-regime-weightage.vue');
const OtherSourcesWeightage = () => import ('./other-sources-weightage.vue');
const LumpSumPayment = () => import ('./lump-sum-payment.vue');
const RatesOfDeduction = () => import ('./rates-of-deduction.vue');

export default {
    name: 'performance_assesment_settings',
    components: {
        ContractSum,
        PerformanceComputation,
        MaintenanceRegimeWeightage,
        OtherSourcesWeightage,
        LumpSumPayment,
        RatesOfDeduction,
    },
    data() {
        return {
            tabs: tabData.performance_assesment,
            header: {
                options: {
                    property_types: [],
                    supplier_contracts: []
                },
                data: {
                    property_type: null,
                    supplier_contract: null
                }
            }
        }
    },
    computed: {
        ...mapGetters({
            ClientContractID: 'ContractController/ClientContractID'
        })
    },
    watch: {
        ClientContractID: function(val) {
            this.header.data.supplier_contract = null
            this.getSupplierContract()  
        }
    },
    created() {
        this.getSupplierContract()
        this.getReferences()
    },
    methods: {
        async getSupplierContract(search = "") {
            let tableRequest = {
                filter: {
                    contract_title: { type: "text", value: search, function: "ilike", with: [] },
                    contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : ""
                },
                limit: 100,
                page: 1,
                isCMS: 1,
                useDatabaseView: true,
                sortColumn: "contract_title",
                sortDirection: "ASC"
            }
            await this.$store.dispatch("ContractController/getListSContracts", tableRequest)
            .then(response => {
                this.header.options.supplier_contracts = response.data.data.contracts
            })
            .catch(err => {})
        },
        searchSupplierContract(search, loading){
                loading(true);
                this.header.options.supplier_contracts = []
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    try {
                        await this.getSupplierContract(search);
                        await loading(false);
                    } catch (err) {
                        loading(false);
                    }
                }, 500);
            },
        getReferences() {
            this.header.options.property_types= [
                {
                    reference_value_text: "Residential",
                },
                {
                    reference_value_text: "Hawker Centre",
                }
            ]
            // this.$store.dispatch(`PropertyController/getReferences`, {
            //     filter: { reference_type: 'Property Type' },
            //     limit: -1,
            //     isCMS: true
            // })
            // .then(response => {
            //     this.header.options.property_types = response.data.data.items
            // })
            // .catch(error => {
            //     reject(error);
            // })
        },
    }
}
</script>